import React from "react";

import { TimeFrame } from "@fartherfinance/frontend/api/PerformanceGroups/hooks/Types";

import TrendingDown from "@src/assets/svg/components/TrendingDown";
import TrendingUp from "@src/assets/svg/components/TrendingUp";
import TimeRangeSelector from "@src/multiCustodian/components/PerformanceGroups/Shared/TimeRangeSelector";
import Card from "@src/sharedComponents/Card/Card";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./HouseholdAccounts.module.css";

interface FartherPerformanceCardProps {
  performance: string;
  timeFrame: TimeFrame;
  timeFrameOptions: TimeFrame[];
  onSetTimeRange: (timeRange: TimeFrame) => void;
  isLoading: boolean;
}

const FartherPerformanceCard = ({
  performance,
  timeFrame,
  timeFrameOptions,
  onSetTimeRange,
  isLoading,
}: FartherPerformanceCardProps): JSX.Element => {
  const isNegative = performance.startsWith("-");
  const textColor = isNegative ? "textDanger" : "textSuccess";
  const TrendingIcon = isNegative ? TrendingDown : TrendingUp;

  return (
    <Card
      className={styles.performanceCard}
      header={
        <div className={styles.performanceCardHeader}>
          <Text variant="body" color="textSubtle">
            Farther Performance
          </Text>
          {!isLoading && <TrendingIcon className={styles.trendingIcon} />}
        </div>
      }
    >
      {isLoading ? (
        <Skeleton
          width="80px"
          height="32px"
          className={styles.performanceText}
        />
      ) : (
        <Text
          variant="title2"
          color={textColor}
          className={styles.performanceText}
        >
          {performance}
        </Text>
      )}
      {isLoading ? (
        <Skeleton
          width="200px"
          height="32px"
          className={styles.timeRangeSelector}
        />
      ) : (
        <TimeRangeSelector
          timeRange={timeFrame}
          timeFrameOptions={timeFrameOptions}
          className={styles.timeRangeSelector}
          setTimeRange={onSetTimeRange}
          isDisabled={false}
        />
      )}
    </Card>
  );
};

export default FartherPerformanceCard;
